import type { ISeoPage } from '@dev-fast/types';

export const LOBBY_SEO_PAGES: ISeoPage[] = [];
